var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconListDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.941,
    height: 12,
    viewBox: "0 0 15.941 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_list_dark_grey",
    "data-name": "Icon/list/dark grey",
    transform: "translate(0 -7.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51033",
    "data-name": "Path 51033",
    d: "M25.832,47.547H14.747a.827.827,0,0,1,0-1.654H25.831a.827.827,0,0,1,0,1.654Z",
    transform: "translate(-10.716 -28.333)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51034",
    "data-name": "Path 51034",
    d: "M25.832,28.716H14.747a.827.827,0,0,1,0-1.654H25.831a.827.827,0,0,1,0,1.654Z",
    transform: "translate(-10.716 -14.455)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51035",
    "data-name": "Path 51035",
    d: "M25.832,9.885H14.747a.827.827,0,1,1,0-1.654H25.831a.827.827,0,0,1,0,1.654Z",
    transform: "translate(-10.716 -0.577)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2489",
    "data-name": "Ellipse 2489",
    cx: 1.111,
    cy: 1.111,
    r: 1.111,
    transform: "translate(0 7.434)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2490",
    "data-name": "Ellipse 2490",
    cx: 1.111,
    cy: 1.111,
    r: 1.111,
    transform: "translate(0 12.323)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2491",
    "data-name": "Ellipse 2491",
    cx: 1.111,
    cy: 1.111,
    r: 1.111,
    transform: "translate(0 17.212)",
    fill: "#4b4b4b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListDark);
export default __webpack_public_path__ + "static/media/icon_list_dark.abd06623d0086df56ce09d5b5921d850.svg";
export { ForwardRef as ReactComponent };